import type { dataGridSortDirection } from '@shared/components';
import { useCallback, useState } from 'react';

// TODO: refactor this if this got promoted to @shared/utils
type SortOrder = (typeof dataGridSortDirection)[number];

interface SelectPublishedQSetDatagridParams {
  page: number;
  pageSize: number;
  sortOrder: SortOrder;
  sortBy: string;
}

const initialDatagridParams: SelectPublishedQSetDatagridParams = {
  page: 0,
  pageSize: 10,
  sortOrder: 'asc',
  sortBy: 'code',
};

export default function useQSetSearchState() {
  const [datagridParams, setDatagridParams] =
    useState<SelectPublishedQSetDatagridParams>(initialDatagridParams);

  const changePageNumber = useCallback(
    (page: number) => {
      setDatagridParams((prev) => ({ ...prev, page }));
    },
    [setDatagridParams],
  );

  const changePageSize = useCallback(
    (pageSize: number) => {
      setDatagridParams((prev) => ({ ...prev, pageSize }));
    },
    [setDatagridParams],
  );

  const changeSorting = useCallback(
    ({
      sortOrder = initialDatagridParams.sortOrder,
      sortBy = initialDatagridParams.sortBy,
    }: {
      sortOrder?: SortOrder;
      sortBy?: string;
    }) => {
      setDatagridParams((prev) => ({ ...prev, sortOrder, page: 0, sortBy }));
    },
    [setDatagridParams],
  );

  return [
    datagridParams,
    {
      changePageNumber,
      changePageSize,
      changeSorting,
    },
  ] as const;
}
